import { useDispatch, useSelector } from 'react-redux';
import { Icon } from '@nazka/nazka.mapframe.components';
import { faArrowDown } from '@fortawesome/pro-solid-svg-icons';

import { legendOptions } from './source-legend.constants';
import { setSelectedMode } from './source-legend.store';
import './sources-legend.css';

const scaleValuesByMode = {
  'potential': {
    left: ['4200', '3360', '2520', '1680', '840', '0'],
    right: ['900', '720', '540', '360', '180', '0'],
    label: 'Bronpotentieel in GWh per jaar',
    unit: 'GWh/jaar',
  },
  'temperature': {
    left: ['2', '1.6', '1.2', '0.8', '0.4', '0'],
    right: ['2', '1.6', '1.2', '0.8', '0.4', '0'],
    label: 'Temperatuurdaling',
    unit: '°C',
  },
  'heat-delivered': {
    left: ['800', '640', '480', '320', '160', '0'],
    right: ['200', '160', '120', '80', '40', '0'],
    label: 'Totale warmte geleverd in GWh per jaar',
    unit: 'GWh/jaar',
  },
};

function SourcesLegend({ onModeChange }) {
  const dispatch = useDispatch();
  const selectedMode = useSelector(state => state.sourceLegend.selectedMode);
  const scaleValues = scaleValuesByMode[selectedMode];

  return (
    <div className="sources-legend">
      <div className="sources-legend__switch" role="group" aria-label="Legendaweergave">
        {legendOptions.map(({ label, value }) => (
          <button
            className={`sources-legend__switch-option${selectedMode === value ? ' sources-legend__switch-option--selected' : ''}`}
            key={value}
            type="button"
            aria-pressed={selectedMode === value}
            onClick={() => {
              dispatch(setSelectedMode(value));
              onModeChange?.(value);
            }}
          >
            {label}
          </button>
        ))}
      </div>
      <div
        className="sources-legend__scale"
        role="img"
        aria-label={scaleValues.label}
      >
        <div className="sources-legend__header">
          <span>rivieren</span>
          <span>andere</span>
        </div>
        <div className="sources-legend__units">
          <Icon icon={faArrowDown} size="10px" />
          <span>{scaleValues.unit}</span>
          <Icon icon={faArrowDown} size="10px" />
        </div>
        <div className="sources-legend__values">
          <div className="sources-legend__labels sources-legend__labels--left">
            {scaleValues.left.map(value => (
              <span key={value}>{value}</span>
            ))}
          </div>
          <div className="sources-legend__gradient" />
          <div className="sources-legend__labels sources-legend__labels--right">
            {scaleValues.right.map(value => (
              <span key={value}>{value}</span>
            ))}
          </div>
        </div>
        <span className="sources-legend__zero">0</span>
      </div>
    </div>
  );
}

export default SourcesLegend;
